export const messages = {
  securemessage: {
    id: 'secureMessage.Button',
    defaultMessage: 'Send Secure Message',
  },
  moreLink: {
    id: 'careTeamMemberCard.button.more',
    defaultMessage: 'More...',
  },
  popOverTitle: {
    id: 'contactDetails.PopOverTitle',
    defaultMessage: 'Contact Details',
  },
};
